<ng-template #tagRecordPopup>
    <div class="page-loading-shade" *ngIf="isProcessing">
      <app-custom-spinner *ngIf="isProcessing"></app-custom-spinner>
    </div>

    <button class="close close-button" mat-button (click)="canceltagRecordPopup()">
      <i class="fa popupClose">&#xf00d;</i>
    </button>

    <div mat-dialog-title>
      <label for="title" class="popupTitle"> {{labelName}} </label>
      <label for="app-name" class="popupAppTitle">One<span style="color:gold;">QMS</span> </label>
    </div>

    <div class="form-continer">
      <div class="row">
        <!-- tagRef -->
        <div class="col-md-12">
          <div><label for="email ">Tag Reference</label>
            </div>
            <input class="input-filed-continers" type="text" placeholder="" [(ngModel)]="homepageTagData.tagRef">
        </div>
        <div class="pt-2 col-md-4">
            <div><label for="email ">Tag Permanently</label>
              </div>
            <mat-slide-toggle color="primary" [(ngModel)]="homepageTagData.tagPermanently">
              <span class="active-inActive-container" *ngIf="homepageTagData.tagPermanently==true"
                [ngStyle]="homepageTagData.tagPermanently==true?{'color':'green', 'font-weight':'500'} : {'color': ''}">Yes</span>
              <span *ngIf="homepageTagData.tagPermanently==false"
                [ngStyle]="homepageTagData.tagPermanently==false?{'color':'red', 'font-weight':'500'} : {'color': ''}">No</span>
            </mat-slide-toggle>
          </div>
          <div class="pt-2 col-md-4" [hidden]="homepageTagData.tagPermanently">
            <div><label id="tagTill-validation"
                for="email">Tag Till<span class="mandatory-symbol">*</span></label>
             </div>
            <input type="text" class="form-control data-picker-continer" bsDatepicker 
              [bsConfig]="$present_future_config " [dateCustomClasses]="dateCustomClasses"
              [(ngModel)]="homepageTagData.tagTill"
             >
          </div>
      </div>
    </div>

    <div class="button-continer btn-align" mat-dialog-actions style="margin-top: 2%;">
      <button mat-stroked-button class="addButton" (click)="executeTagUntag()">
        <i class="fas fa-tag" style="color:white"></i> {{labelName}}
      </button>
      <button mat-stroked-button class="cancelButton" (click)="canceltagRecordPopup()">
        <i class="fas fa-close"></i> Cancel
      </button>
    </div>
  </ng-template>

<ng-template #confirmationPopup>
    <div class="page-loading-shade" *ngIf="isProcessing">
      <app-custom-spinner *ngIf="isProcessing"></app-custom-spinner>
    </div>
    <button class="close close-button" (click)="closeConfirmationPopup()" mat-button>
      <i class="fa popupClose">&#xf00d;</i>
    </button>
    <div mat-dialog-title>
      <label for="title" class="popupTitle"> Confirmation </label>
      <label for="app-name" class="popupAppTitle">One<span style="color:gold;">QMS</span> </label>
    </div>
    <div style="margin: 15px 15px;" class="center">
      <label for="email" style="font-size: medium; font-weight: bold;">
        Do you want to Tag this record?</label>
    </div>

    <div class="button-continer btn-align" mat-dialog-actions style="margin-top: 2%;">
      <button mat-stroked-button class="addButton" (click)="executeTagUntag()">
        <i class="fa fa-check"></i> Yes
      </button>
      <button mat-stroked-button class="cancelButton" (click)="closeConfirmationPopup()">
        <i class="fas fa-close"></i> No
      </button>
    </div>
  </ng-template>